import { useRepositoryQuery } from '@mews-commander/data-access';

export function useLanguages() {
    return useRepositoryQuery('globalization', 'get', {}, { select: (data) => data?.languages || [] });
}
